/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../SharedModules/CustomAgGridEditor/inputComponent';
import { cellRenderer } from '../../../SharedModules/utilities/utilities';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const d1 = date1?.includes('-') ? date1?.split('-')[1] : date1;
  const d2 = date2?.includes('-') ? date2?.split('-')[1] : date2;
  const date1Number = monthToComparableNumber(d1);
  const date2Number = monthToComparableNumber(d2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}
export const tableHead = [
  {
    headerName: '',
    children: [
      {
        headerName: 'Date Range',
        field: 'abc',
        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        // sort: 'asc',
        comparator: dateComparator,
        minWidth: Styles.Width_250,
        cellEditor: MaxLengthNumericEditor,
        cellStyle: { borderRightColor: Styles.BorderColor },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
    ],
  },
  {
    headerName: 'Total',
    children: [
      {
        headerName: ' Principal',
        field: 'total_principal',

        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        cellRenderer: cellRenderer,
        comparator: amountComparator,
        isTextColorRed: true,
        printPrefixValue: '$',
        minWidth: Styles.Width_180,
        cellEditor: MaxLengthNumericEditor,
        // sortingOrder: ["desc", "asc"],
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Interest',
        field: 'total_interest',
        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        comparator: amountComparator,
        cellRenderer: cellRenderer,
        isTextColorRed: true,
        printPrefixValue: '$',
        minWidth: Styles.Width_180,
        cellEditor: MaxLengthNumericEditor,
        // sortingOrder: ["desc", "asc"],
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Total',
        field: 'total',
        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        comparator: amountComparator,
        cellRenderer: cellRenderer,
        isTextColorRed: true,
        printPrefixValue: '$',
        minWidth: Styles.Width_171,
        cellEditor: MaxLengthNumericEditor,
        // sortingOrder: ["desc", "asc"],
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
    ],
  },
  {
    headerName: 'Rebate',
    children: [
      {
        headerName: ' Principal',
        field: 'rebate_principal_paid_amt',

        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        comparator: amountComparator,
        cellRenderer: cellRenderer,
        isTextColorRed: true,
        printPrefixValue: '$',
        minWidth: Styles.Width_180,
        cellEditor: MaxLengthNumericEditor,
        // sortingOrder: ["desc", "asc"],
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Interest',
        field: 'rebate_interest_paid_amt',
        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        // sort: "asc",
        minWidth: Styles.Width_180,
        cellEditor: MaxLengthNumericEditor,
        comparator: amountComparator,
        cellRenderer: cellRenderer,
        isTextColorRed: true,
        printPrefixValue: '$',
        // sortingOrder: ["desc", "asc"],
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Total',
        field: 'rebate_total',
        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        comparator: amountComparator,
        cellRenderer: cellRenderer,
        isTextColorRed: true,
        printPrefixValue: '$',
        minWidth: Styles.Width_171,
        cellEditor: MaxLengthNumericEditor,
        // sortingOrder: ["desc", "asc"],
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
    ],
  },
  {
    headerName: 'Dispute',
    children: [
      {
        headerName: ' Principal',
        field: 'dispute_principal_paid_amt',
        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        comparator: amountComparator,
        cellRenderer: cellRenderer,
        isTextColorRed: true,
        printPrefixValue: '$',
        minWidth: Styles.Width_180,
        cellEditor: MaxLengthNumericEditor,
        // sortingOrder: ["desc", "asc"],
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Interest',
        field: 'dispute_interest_paid_amt',
        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        comparator: amountComparator,
        cellRenderer: cellRenderer,
        isTextColorRed: true,
        printPrefixValue: '$',
        minWidth: Styles.Width_171,
        cellEditor: MaxLengthNumericEditor,
        // sortingOrder: ["desc", "asc"],
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },

        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Total',
        field: 'dispute_total',
        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        cellRenderer: cellRenderer,
        comparator: amountComparator,
        isTextColorRed: true,
        printPrefixValue: '$',
        minWidth: Styles.Width_125,
        cellEditor: MaxLengthNumericEditor,

        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
    ],
  },
  {
    headerName: 'Combined',
    children: [
      {
        headerName: ' Principal',
        field: 'principal_paid_amt',
        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        cellRenderer: cellRenderer,
        comparator: amountComparator,
        isTextColorRed: true,
        printPrefixValue: '$',
        autoHeight: true,
        wrapText: true,
        // sort: "asc",
        minWidth: Styles.Width_200,
        cellEditor: MaxLengthNumericEditor,
        // sortingOrder: ["desc", "asc"],
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Interest',
        field: 'interest_paid_amt',
        editable: false,
        sortable: true,
        suppressMenu: false,
        cellRenderer: cellRenderer,
        comparator: amountComparator,
        isTextColorRed: true,
        printPrefixValue: '$',
        autoHeight: true,
        wrapText: true,
        resizable: true,
        // sort: "asc",
        minWidth: Styles.Width_180,
        cellEditor: MaxLengthNumericEditor,
        // sortingOrder: ["desc", "asc"],
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Total',
        field: 'combined_total',
        editable: false,
        sortable: true,
        suppressMenu: false,
        resizable: true,
        isTextColorRed: true,
        cellRenderer: cellRenderer,
        comparator: amountComparator,

        printPrefixValue: '$',
        minWidth: Styles.Width_150,
        cellEditor: MaxLengthNumericEditor,
        cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
    ],
  },
];
export const demo = [];
